import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1497007874735639';
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Avoid double-initialization
    if ((window as any).fbq) {
      try {
        ;
        (window as any).fbq('track', 'PageView');
      } catch (e) {
        // no-op
      }
      return;
    }
    // Inline Meta Pixel base code (verbatim from Meta)
    /* eslint-disable */
    ;
    (function (f: any, b: any, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      const t: any = b.createElement(e);
      t.async = !0;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        ;
        (b.head || b.documentElement).appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', PIXEL_ID);
    (window as any).fbq('track', 'PageView');
    // Inject the <noscript> fallback pixel (for users with JS disabled / verification crawlers)
    if (!document.getElementById('meta-pixel-noscript')) {
      const noscript = document.createElement('noscript');
      noscript.id = 'meta-pixel-noscript';
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  }, []);
  return null;
}